(function($) {

	'use strict';

	var init = function() {

        if($('.fp-timeline').length > 0) {

            // spacingTimelineFP();

            fpPopupVideo();

        }
        
    };
    
    var spacingTimelineFP = function() {
        
        var heightOdd = 0
        var heightEven = 0

        $(window).resize(function() {
            if($(window).width() > 767) {
                $('.fp-timeline__wrapper:nth-child(odd)').each(function() {
                    heightOdd += $(this).height()
                    $(this).next().css('top', heightOdd + 50 + 'px')
                })
                $('.fp-timeline__wrapper:nth-child(even)').each(function() {
                    heightEven += $(this).height()
                    $(this).next().css('top', heightEven + 50 + 'px')
                })
            } else {
                $('.fp-timeline__wrapper').css('top', '0')
            }
        }).resize()

    }

    var fpPopupVideo = function() {

        var top = 0;

        var video = document.getElementsByClassName("video-iframe");

        $('.popup-trigger').each(function() {

            $(this).click(function() {
                if($(this).parentsUntil('.popup-parent').find('.popup').hasClass('active') == true) {
                    $(this).parentsUntil('.popup-parent').find('.popup').removeClass('active');
                        setTimeout(function() {
                            $('body').toggleClass('open');
                            $('.join-us').toggleClass('body-is-open');
                            $('html, body').scrollTop(top);
                        }, 450);

                        for (var i=0; i<video.length; i++) {
                            video.item(i).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                        }

                    setTimeout(function() {
                        $('.popup-opener').each(function() {
                            $(this).removeClass('active');
                        });
                    }, 50);
                }
            });
        });

        $('.popup-opener').each(function(index) {

            $(this).click(function() {
                
                if($(this).hasClass('active') == false) {
                    $(this).find('.popup').addClass('active');
                    $(this).addClass('active');
                        top = $(window).scrollTop();
                        $('body').toggleClass('open');
                        $('.join-us').toggleClass('body-is-open');
                        $('body').scrollTop(top);

                        setTimeout(function() {
                            video.item(index).contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                        }, 450);
                }
            })
        });
    }

	$(document).ready(function() {
        init();
	});

})(jQuery);
